import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Iconify from '../Iconify/Iconify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Iconify icon="material-symbols:close" color="#3a3a3a" width={22} height={22} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function Modal(props: any) {

  return (
    <BootstrapDialog
      onClose={() => {props.setOpenModal(false);}}
      aria-labelledby="customized-dialog-title"
      open={props.openModal}
      className={props.className}
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={() => {props.setOpenModal(false);}}>
        {props.modalTitle}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        {props.modalContent}
      </DialogContent>
    </BootstrapDialog>
  );
}
